<template>
  <!-- 企业介绍 -->
  <el-row type="flex" justify="center">
    <el-col :md="18" :lg="14">
      <!-- <el-image :src="require('@/assets/images/zp.jpg')"></el-image> -->
      <ul class="navList">
        <li
          v-for="(item, index) in navList"
          :key="item.url"
          :class="{ active: activeIndex1 == index }"
          @click="changeItem(item, index)"
        >
          <el-image :src="item.url"></el-image>
          <div>{{ item.text }}</div>
        </li>
      </ul>

      <keep-alive>
        <transition mode="out-in" name="el-fade-in">
          <router-view class="bgc"></router-view>
        </transition>
      </keep-alive>
    </el-col>
  </el-row>
</template>

<script>
export default {
  mounted() {
    // let index = sessionStorage.getItem("activeIndex1");
    // index == undefined ? (this.activeIndex1 = 0) : (this.activeIndex1 = index);
  },
  methods: {
    changeItem(obj, i) {
      this.activeIndex1 = i;
      this.$router.push({ name: obj.name }).catch((err) => {
        console.log(err);
      });
      // sessionStorage.setItem("activeIndex1", i);
    },
  },
  data() {
    return {
      activeIndex1: 0,
      navList: [
        {
          name: "company1",
          url: require("@/assets/images/书籍.png"),
          text: "公司简介",
        },
        {
          name: "company2",
          url: require("@/assets/images/培训.png"),
          text: "企业文化",
        },
        {
          name: "company3",
          url: require("@/assets/images/对话.png"),
          text: "公司环境",
        },
        {
          name: "company4",
          url: require("@/assets/images/奖牌.png"),
          text: "所获荣誉",
        },
      ],
    };
  },
};
</script>

<style scoped lang='less'>
.bgc {
  // border: 1px solid red;
}
.el-divider {
  margin: 50px 0;
  // background-color: #eb4b27;
  height: 4px;
}
.navList {
  // border: 1px solid red;
  box-shadow: 0 0 5px 1px #eee;
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  // margin-bottom: 30px;
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // border: 1px solid red;
    padding: 10px;
    font-size: 18px;
    .el-image {
      margin-right: 5px;
      width: 25px;
      height: 25px;
    }
    div {
      color: #424951;
    }
    &.active {
      div {
        color: #ffa500;
      }
    }
  }
}

.culture {
  // border: 1px solid red;
  .el-col {
    border: 1px solid red;
    &:last-child {
      .title {
        background-color: #149ca8;
      }
    }
    .title {
      text-align: center;
      background-color: #eb4b27;
      color: #fff;
      line-height: 50px;
      border-radius: 10px;
    }
    .circles {
      border: 1px solid red;
      display: flex;
      .circle {
        // width: 200px;
        // height: 200px;
        border: 1px solid red;
        border-radius: 50%;
        overflow: hidden;
        .el-image {
        }
        // height: 100px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
}

@media screen and(max-width: 576px) {
  .navList {
    li {
      padding: 2px;
      div {
        font-size: 12px;
      }
    }
  }
}
</style>
